import { render, staticRenderFns } from "./ContactoSection.vue?vue&type=template&id=4a84bc14&scoped=true"
import script from "./ContactoSection.vue?vue&type=script&lang=js"
export * from "./ContactoSection.vue?vue&type=script&lang=js"
import style0 from "./ContactoSection.vue?vue&type=style&index=0&id=4a84bc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a84bc14",
  null
  
)

export default component.exports